import * as i18next from 'i18next';
import { G2S } from '../g2s';
import * as api from '../api';
import * as flights from '../flights';

export class Baggage {
    static getLabel(flightBaggage: api.FlightBaggage, isCabin: boolean, short = false): string {
        let label = '';
        const suffix = isCabin ? '_cabin' : '';

        if (flightBaggage) {
            if (flightBaggage.pieceWeight == 0 && flightBaggage.pieces == 0) {
                label = short
                    ? i18next.t('label_baggage' + suffix + '_without_short')
                    : i18next.t('label_baggage' + suffix + '_without');
            } else {
                if (flightBaggage.pieceWeight > 0) {
                    label = flightBaggage.pieceWeight + G2S.nbsp + i18next.t('label_kg');

                    if (flightBaggage.pieces > 1) {
                        label = flightBaggage.pieces + G2S.nbsp + 'x' + G2S.nbsp + label;
                    }
                } else {
                    if (flightBaggage.pieces > 0) {
                        label = i18next.t('numerous_baggage_piece', { count: flightBaggage.pieces });
                    }
                }

                if (label && !short) {
                    label = i18next.t('label_baggage' + suffix + '_value', <any>{ i: label });
                }

                if (flightBaggage.length && flightBaggage.width && flightBaggage.height && !short) {
                    label = `${label}${G2S.nbsp}(${flightBaggage.length}x${flightBaggage.width}x${flightBaggage.height}${G2S.nbsp}${i18next.t('label_cm')})`;
                }
            }
        }

        if (!label) {
            label = i18next.t('label_baggage' + suffix + '_unknown');
        }

        return label;
    }

    static getValue(legOrSegment: flights.LegModel | flights.SegmentModel): string {
        let baggageCabin = '';
        let baggage = '';

        if (legOrSegment.baggage && (legOrSegment.baggage.pieceWeight === 0 && legOrSegment.baggage.pieces === 0)) {
            return i18next.t('label_baggage_without_short');
        }

        if (legOrSegment.baggageCabin) {
            if (legOrSegment.baggageCabin.pieceWeight > 0) {
                baggageCabin = legOrSegment.baggageCabin.pieceWeight + G2S.nbsp + i18next.t('label_kg');

                if (legOrSegment.baggageCabin.pieces > 1) {
                    baggageCabin = legOrSegment.baggageCabin.pieces + G2S.nbsp + 'x' + G2S.nbsp + baggageCabin;
                }
            } else {
                if (legOrSegment.baggageCabin.pieces > 0) {
                    baggageCabin = i18next.t('numerous_baggage_piece', { count: legOrSegment.baggageCabin.pieces });
                }
            }
        }

        if (legOrSegment.baggage) {
            if (legOrSegment.baggage.pieceWeight > 0) {
                baggage = legOrSegment.baggage.pieceWeight + G2S.nbsp + i18next.t('label_kg');

                if (legOrSegment.baggage.pieces > 1) {
                    baggage = legOrSegment.baggage.pieces + G2S.nbsp + 'x' + G2S.nbsp + baggage;
                }
            } else {
                if (legOrSegment.baggage.pieces > 0) {
                    baggage = i18next.t('numerous_baggage_piece', { count: legOrSegment.baggage.pieces });
                }
            }
        }

        if (baggageCabin || baggage) {
            if (baggage) {
                if (baggageCabin) {
                    baggageCabin += G2S.nbsp + '+' + G2S.nbsp;
                }

                baggageCabin += baggage;
            }

            return baggageCabin;
        }

        return G2S.nbsp;
    }

    static getBaggageValue(legOrSegment: flights.LegModel | flights.SegmentModel): string {
        let baggage = '';

        if (legOrSegment.baggage && (legOrSegment.baggage.pieceWeight === 0 && legOrSegment.baggage.pieces === 0)) {
            return i18next.t('label_baggage_without_short');
        }

        if (legOrSegment.baggage) {
            if (legOrSegment.baggage.pieceWeight > 0) {
                baggage = legOrSegment.baggage.pieceWeight + G2S.nbsp + i18next.t('label_kg');

                if (legOrSegment.baggage.pieces > 1) {
                    baggage = legOrSegment.baggage.pieces + G2S.nbsp + 'x' + G2S.nbsp + baggage;
                }
            } else {
                if (legOrSegment.baggage.pieces > 0) {
                    baggage = i18next.t('numerous_baggage_piece', { count: legOrSegment.baggage.pieces });
                }
            }
        }

        return baggage;
    }

    static getBaggageCabinValue(legOrSegment: flights.LegModel | flights.SegmentModel): string {
        let baggageCabin = '';

        if (legOrSegment.baggageCabin && (legOrSegment.baggageCabin.pieceWeight === 0 && legOrSegment.baggageCabin.pieces === 0)) {
            return i18next.t('label_baggage_cabin_without_short');
        }

        if (legOrSegment.baggageCabin) {
            if (legOrSegment.baggageCabin.pieceWeight > 0) {
                baggageCabin = legOrSegment.baggageCabin.pieceWeight + G2S.nbsp + i18next.t('label_kg');

                if (legOrSegment.baggageCabin.pieces > 1) {
                    baggageCabin = legOrSegment.baggageCabin.pieces + G2S.nbsp + 'x' + G2S.nbsp + baggageCabin;
                }
            } else {
                if (legOrSegment.baggageCabin.pieces > 0) {
                    baggageCabin = i18next.t('numerous_baggage_piece', { count: legOrSegment.baggageCabin.pieces });
                }
            }
        }

        return baggageCabin;
    }

    static hasFreeBaggage(flight: flights.FlightModel): boolean {
        if (flight.legs[0].baggage
            && (flight.legs[0].baggage.pieceWeight > 0
                || flight.legs[0].baggage.pieces > 0
            )) {
            return true;
        }

        return false;
    }
}
